export const MOBILE_BREAK_POINT = '(max-width: 767px)';
export const SMALL_TABLET_BREAK_POINT = '(min-width: 768px) and (max-width: 1120px)';
export const DESKTOP_BREAK_POINT = '(min-width: 1121px)';
